<template>
  <div>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      :html-to-pdf-options="{ margin: [15, 20], filename: fileName() }"
      @hasDownloaded="setLoad()"
      ref="html2Pdf"
    >
    <!-- Seu conteúdo HTML aqui -->
      <section slot="pdf-content">
        <div id="imprimir">
          <div style="width: 630px;">
          <p class="titulo">
            <span>ORÇAMENTO</span>
          </p>
          <p class="nome" style="text-align: center;">
            <span style="float: left;">Cliente: {{ user.nome }}</span>
            <span> {{ user.email }}</span>
            <span style="float: right;">Celular: {{ user.cel }}</span>
          </p>
          <p class="nome" style="margin-top: 8px; margin-bottom: 30px;">
            <strong style="float: left;"> O.S.: {{ orcamento.id }}</strong>
            <strong style="float: right;">Data: {{ datahora }}</strong>
          </p>
        </div>
          <div style="margin: 10px; padding: 20px;">
              <p class="lista">
                <strong class="spacer">Tipo:</strong><span>{{orcamento.tipo}}</span>
              </p> 
              <p class="lista">
                <strong class="spacer">Tamanho:</strong><span>{{orcamento.tamanho}}</span>
              </p> 
              <p class="lista">
                <strong class="spacer">Lâminas:</strong><span>{{laminas(orcamento)}}</span>
              </p> 
              <p class="lista" v-if="orcamento.tipo !== 'Álbum Slim'">
                <strong class="spacer">Capa:</strong><span>{{orcamento.capa}}</span>
              </p> 
              <p class="lista" v-if="orcamento.tipo !== 'Álbum Slim' && orcamento.capa !== 'Capa foto'">
                <strong class="spacer">{{ "Mostruário:" }}</strong><span>{{ orcamento.mostruario }}</span>
              </p> 
              <p class="lista">
                <strong class="spacer">Laminação:</strong><span>{{orcamento.laminacao}}</span>
              </p>
              <p class="lista">
                <strong>Acessórios:</strong>
              </p> 
              <p v-for="(item, i) in orcamento.acessorios" :key="i" style="margin-left:20px;" class="lista">
                <span class="ml-10">{{item}}</span>
              </p>
              <p class="lista">
                <strong class="spacer">Valor total:</strong><span>{{orcamento.valor}}</span>
              </p>
          </div>
          <div style="width: 630px; border: 1px solid; padding: 10px;">
            <p>
              <strong>Observações:</strong>
            </p>
            <p style="margin-top: 6px;">
              <span>{{ obs }}</span>
            </p>
          </div>
            <p style="margin-top: 30px;">
              <strong class="spacer">Envio: </strong><span class="spacer">{{ envio }}</span>
            </p>
        </div>
      </section>
    </vue-html2pdf>

    <v-row class="ma-4">
      <v-col cols="10" offset="1">
        <div id="imprimir">
          <!-- Inicio da impressão  -->
          <p class="titulo">
            <span>ORÇAMENTO</span>
          </p>
          <p class="nome" style="text-align: center;">
            <span style="float: left;">Cliente: {{ user.nome }}</span>
            <span> {{ user.email }}</span>
            <span style="float: right;">Celular: {{ user.cel }}</span>
          </p>
          <p class="nome" style="margin-top: 4px; margin-bottom: 30px;">
            <strong style="float: left;"> O.S.: {{ orcamento.id }}</strong>
            <strong style="float: right;">Data: {{ datapedido }}</strong>
          </p>
          <div style="margin: 10px; padding: 20px;">
              <p class="lista">
                <strong class="spacer">Tipo:</strong><span>{{orcamento.tipo}}</span>
              </p> 
              <p class="lista">
                <strong class="spacer">Tamanho:</strong><span>{{orcamento.tamanho}}</span>
              </p> 
              <p class="lista">
                <strong class="spacer">Lâminas:</strong><span>{{laminas(orcamento)}}</span>
              </p> 
              <p class="lista" v-if="orcamento.tipo !== 'Álbum Slim'">
                <strong class="spacer">Capa:</strong><span>{{orcamento.capa}}</span>
                <strong v-if="orcamento.capa !== 'Capa foto'" class="spacem">{{ "Mostruário:" }}</strong><span>{{ orcamento.mostruario }}</span>
              </p> 
              <p class="lista">
                <strong class="spacer">Laminação:</strong><span>{{orcamento.laminacao}}</span>
              </p> 
              <p class="lista">
                <strong>Acessórios:</strong>
              </p> 
              <p v-for="(item, i) in orcamento.acessorios" :key="i" class="lista">
                <span class="ml-10">{{item}}</span>
              </p>
              <p class="lista">
                <strong class="spacer">Valor total:</strong><span>{{orcamento.valor}}</span>
              </p>
          </div>
            <!-- <p>
              <strong>Observações:</strong>
            </p>
            <p>
              <strong>{{ obs }}</strong>
            </p>
            <p>
              <strong class="spacer">Envio: </strong><span class="spacer">{{ envio }}</span><strong class="spacel">Pagamento: </strong><span class="spacer">{{ pgto }}</span>
            </p> -->
            <!-- fim da impressão  -->
          <div class="pa-4">
            <v-row class="ma-2">

              <v-textarea
                class="pa-2"
                background-color="secondary"
                color="primary"
                label="Observações"
                placeholder="Opcional"
                v-model="obs"
              ></v-textarea>

            </v-row>
            
            <v-row>
            <v-col cols="12" sm="6">
            <v-form ref="form" v-model="formValid">
                <v-select
                  :items="itemsEnvio"
                  v-model="envio"
                  :rules="[value => !!value || 'Obrigatório.']"
                  label="Forma de envio"
                  @change="validateField('envio')"
                ></v-select>
              </v-form>
            </v-col>
              <v-col cols="12" sm="6">
              <!-- <v-select
              :items="itemsPgto"
              v-model="pgto"
              :rules="[value => !!value || 'Obrigatório.']"
              label="Forma de pagamento"
              @input="validateField('pgto')"
              ></v-select> -->
              <v-row v-if="envio === 'SIGI'" class="align-center justify-center primary--text">
                  <p><strong>Caso necessite instalar o SIGI-PRO</strong></p>
                  <p><span>Escolha um dos botões abaixo:</span></p>
                </v-row>
                <v-row v-if="envio === 'WeTransfer'" class="align-center justify-center primary--text">
                  <p><strong>Encaminhe para nós o link do envio</strong></p>
                  <p><v-btn link text target="_blanc" color="primary" href="https://wetransfer.com">wetransfer.com</v-btn></p>
                </v-row>
              </v-col>
            </v-row>

            <SIGI v-if="envio === 'SIGI'" />
            <WeTransfer v-if="envio === 'WeTransfer'" />

          </div>
        </div>
        <div class="rodape">
          <v-row class="mt-4">
            <v-spacer></v-spacer>
            <v-btn
              tile
              :loading="loading"
              :disabled="disabled"
              color="primary"
              class="mr-4"
              @click="generateReport()"
              >Gerar PDF</v-btn
            >
            <v-spacer></v-spacer>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VueHtml2pdf from "vue-html2pdf";
import SIGI from "../components/SIGI.vue"
import WeTransfer from "../components/WeTransfer.vue"

export default {
  name: "view-page",
  components: {
    VueHtml2pdf,
    SIGI,
    WeTransfer
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    orcamento() {
      return this.$store.getters.orcamento;
    },
  },
  watch: {
    orcamento(o) {
      console.log(o)
    }
  },
  mounted() {
    this.obs = this.orcamento.obs || ""
  },
  data() {
    return {
      loading: false,
      disabled: true,
      formValid: false,
      datapedido: new Date().toLocaleDateString("pt-BR"),
      datahora: "",
      obs: "",
      envio: "",
      itemsEnvio: ["SIGI", "WeTransfer", "Email", "Google Drive", "DropBox", "Pendrive", "Em mãos"],
      pgto: "",
      itemsPgto: ["PIX", "Dinheiro", "Cartão de crédito", "Cartão de débito", "Transferência" ],
    };
  },
  methods: {
    laminas(calc) {
      const num = Number(calc.laminas) + Number(calc.extras);
      return num;
    },
    generateReport() {
      this.loading = true;
      this.disabled = true
      this.datahora = this.dataHora()
      this.$refs.html2Pdf.generatePdf();
    },
    setLoad() {
      console.log("loading");
      this.loading = false;
    },
    fileName() {
      let dt = this.datapedido;
      let part = dt.split("/");
      const data = part[2] + part[1] + part[0] + "_";
      let nome = this.user.nome;
      const cliente = nome.replace(/\s+/g, "-");
      return data + cliente + ".pdf";
    },
    validateField(v) {
      console.log(v, this.envio)
      const valid = this.$refs.form.validate()
      if (valid) {
        this.disabled = false
      } else {
        this.disabled = true
      }
    },
    dataHora() {
      const date = new Date().toLocaleDateString("pt-BR");
      const hora = new Date().toLocaleTimeString("pt-BR");
      return date + " " + hora;
    },
  },
};
</script>

<style scoped>
#imprimir {
  font-family: "Arial";
  margin-bottom: 18px;
}
.spacel {
  margin-left: 12px;
}
.spacer {
  margin-right: 4px;
}
.spacem {
  margin-right: 4px;
  margin-left: 12px;
}
.centro {
  text-align: center;
}
.titulo {
  margin: 10px;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}
.nome {
  border-top: solid 4px #ccc;
  font-size: 12pt;
  padding-top: 4px;
  margin-top: 10px;
  margin-bottom: 5px;
}
.lista {
  margin-bottom: 4px;
  padding: 0;
  padding-left: 20px;
}
.rodape {
  border-top: solid 4px #ccc;
}
.obs {
  margin: 10px 0px;
  padding: 8px 0px;
}
</style>
